// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"20":"2dd1de1a8a67b776","523":"215c77b1c2a12b43","580":"b2d02feb1b03b455"}[chunkId] + ".js";
};